// @ts-nocheck
import React, { FC, useState } from 'react';
import { sendPasswordResetEmail } from "firebase/auth";
import { whichAuth as getAuth } from '../../getAuth';
import { useSetRecoilState } from 'recoil';
import { showSignInState, showForgotPasswordState } from '../../atoms';
import {
  IonContent,
  IonButton,
  IonList,
  IonItem,
  IonInput,
  IonSpinner,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonLabel,
} from '@ionic/react';
import { validationEmail } from "../../utils/validationEmail";
import { AlertModal } from "../../components";

const ForgotPassword: FC = () => {

  const [email, setEmail] = useState<string>('');
  const [inProgress, setInProgress] = useState<boolean>(false);
  const [showPasswordResetSent, setShowPasswordResetSent] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [modalTitle, setModalTitle] = useState<string>('');

  const setShowSignIn = useSetRecoilState(showSignInState);
  const setShowForgotPassword = useSetRecoilState(showForgotPasswordState);

  const resetPassword = () => {
    setInProgress(true)
    sendPasswordResetEmail(getAuth(), email)
      .then(() => {
        setModalMessage('A password reset email has been sent to ' + email)
        setModalTitle('Password reset')
        setIsOpenModal(true)
      })
      .catch(() => {
        setModalMessage('Sorry, we could not find an account for this email address.')
        setModalTitle('Failed to reset password')
        setIsOpenModal(true)
      })
      .finally(() => setInProgress(false));
  }

  return (
    <IonContent fullscreen>
      <IonCardContent className="h-full card-authentication">
        <IonCardContent className="left-authentication" />
        <IonCardContent className="right-authentication">
          <IonList lines="none" className="right-list-authentication">
            <IonCardHeader className="logo-authentication" />
            <IonCardSubtitle className="header-authentication">
              Reset Password
            </IonCardSubtitle>
            <IonLabel className="label-authentication">Email</IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput
                className="input-authentication"
                onIonChange={event => setEmail(event.detail.value)}
                value={email}
                type="email"
                required
              />
            </IonItem>
            <IonItem className="no-padding">
              <IonButton
                disabled={validationEmail(email)}
                onClick={resetPassword}
                size="medium"
                className="button-authentication"
              >
                { inProgress && <IonSpinner name="dots" /> }
                Reset password
              </IonButton>
            </IonItem>
            <IonItem className="already-authentication no-padding">
              Already have an account?
              <a
                className="link-authentication"
                onClick={() => {
                  setShowSignIn(true)
                  setShowForgotPassword(false)
                }}
              >
                Log in
              </a>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCardContent>
      <AlertModal
        isOpen={isOpenModal}
        title={modalTitle}
        subTitle={modalMessage}
        onClosed={() => {
          setIsOpenModal(false)
          if (showPasswordResetSent) {
            setShowPasswordResetSent(false)
            setShowSignIn(true);
            setShowForgotPassword(false);
          }
        }}
      />
    </IonContent>
  );
}

export default ForgotPassword;
